module.exports = __webpack_public_path__ + "media/media/social/insta-ae5e8de07c5ab112cc846a98a18757e9.png";